import React from 'react';
import { Helmet } from '@okapi/helmet-react';

export const MetaCommon = () => (
	<Helmet>
		<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
		<meta content="#444b5b" name="theme-color" />
		<link href="//fonts.googleapis.com" rel="dns-prefetch" />
		<link href="https://res.cloudinary.com/" crossOrigin="anonymous" rel="preconnect" />
		<link href="https://www.googletagmanager.com" crossOrigin="anonymous" rel="preconnect" />
		<link href="https://www.google-analytics.com" crossOrigin="anonymous" rel="preconnect" />
		<link href="https://fonts.gstatic.com" crossOrigin="anonymous" rel="preconnect" />
		<link
			href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900&amp;display=swap&amp;subset=cyrillic"
			rel="stylesheet"
		/>
	</Helmet>
);
